export default __webpack_public_path__ + "static/media/run.910fcb60.svg";